import { Plus } from "lucide-react"

import HourglassEmptyIcon from "@/components/icons/HourglassEmptyIcon"
import { Button } from "@/components/ui/button"

interface EmptyListsStateProps {
  onCreateList: () => void
}

export default function EmptyListsState({
  onCreateList,
}: EmptyListsStateProps) {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
      <HourglassEmptyIcon className="text-bone-dim mb-6 h-24 w-16" />

      <h1 className="font-display text-bone mb-2 text-3xl tracking-wide">
        No deadlines yet.
      </h1>

      <p className="text-bone-muted mb-1 max-w-sm text-base">
        Every task gets a deadline.
      </p>
      <p className="text-bone-dim mb-8 max-w-sm text-sm">
        Complete it in time, or it dies trying.
      </p>

      <Button onClick={onCreateList} size="lg">
        <Plus className="mr-2 h-4 w-4" />
        Create Your First List
      </Button>
    </div>
  )
}
